import {configureStore} from '@reduxjs/toolkit';
import loginReducer from './slices/loginSlice';
import itemsReducer from './slices/itemsSlice';
import tagsReducer from './slices/tagsSlice';
import browseReducer from './slices/browseSlice';
import notificationReducer from './slices/notificationSlice';
import activitiesReducer from './slices/activitiesSlice';
import items2Reducer from './slices/itemsSlice2';
import commentsReducer from './slices/commentsSlice';
import userItemsReducer from './slices/userItemsSlice';
import itemDetailsReducer from './slices/itemDetailsSlice';
import itemContextReducer from './slices/itemContextSlice';
import shareExperienceReducer from './slices/shareExperienceSlice';

export default configureStore({
  reducer: {
    login: loginReducer,
    items: itemsReducer,
    tags: tagsReducer,
    browse: browseReducer,
    notification: notificationReducer,
    activities: activitiesReducer,
    items2: items2Reducer,
    comments: commentsReducer,
    userItems: userItemsReducer,
    itemDetails: itemDetailsReducer,
    itemContext: itemContextReducer,
    shareExperience: shareExperienceReducer,
  }
});